export const GET_HEADLINES = `{
  popups(
    first: 1,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      featuredImage {
        node {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
      }
    }
  }

  news(
    first: 4,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      featuredImage {
        node {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
      }
    }
  }

  stocks(
    first: 4,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      },
      metaQuery: {
        metaArray: {
          key: "sold",
          value: "0"
        }
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      carCategories {
        nodes {
          slug
          name
        }
      }
      makers {
        nodes {
          slug
          name
        }
      }
      acf {
        carImage {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        carPrice
        totalPrice
        capacity
        modelYear
        mileage
        sold
      }
    }
  }

  soldStocks: stocks(
    first: 4,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      },
      metaQuery: {
        metaArray: {
          key: "sold",
          value: "1"
        }
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      carCategories {
        nodes {
          slug
          name
        }
      }
      makers {
        nodes {
          slug
          name
        }
      }
      acf {
        carImage {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        carPrice
        totalPrice
        capacity
        modelYear
        mileage
        sold
      }
    }
  }
}`;
export const GET_RECRUIT = `{
  recruits(
    where: {
      orderby: {
        field: DATE,
        order: DESC
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      content(format: RENDERED)
      acf {
        status
        category
        description
        location
        holidays
        overtime
        benefits
        salary
        bonus
        background
      }
    }
  }

  news(
    first: 4,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      featuredImage {
        node {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
      }
    }
  }

  stocks(
    first: 4,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      },
      metaQuery: {
        metaArray: {
          key: "sold",
          value: "0"
        }
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      carCategories {
        nodes {
          slug
          name
        }
      }
      makers {
        nodes {
          slug
          name
        }
      }
      acf {
        carImage {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        carPrice
        totalPrice
        capacity
        modelYear
        mileage
        sold
      }
    }
  }

  soldStocks: stocks(
    first: 4,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      },
      metaQuery: {
        metaArray: {
          key: "sold",
          value: "1"
        }
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      carCategories {
        nodes {
          slug
          name
        }
      }
      makers {
        nodes {
          slug
          name
        }
      }
      acf {
        carImage {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        carPrice
        totalPrice
        capacity
        modelYear
        mileage
        sold
      }
    }
  }
}`;
//# sourceMappingURL=query.js.map
